import { useDeleteProfileImage, useGetProfileImage, useSaveProfileImage } from "@app/store/service/connectorService"
import { faEllipsis } from "@fortawesome/free-solid-svg-icons/faEllipsis"
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash"
import { faUpload } from "@fortawesome/free-solid-svg-icons/faUpload"
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useToasts } from "@tecreation/funnel-components"
import { useEffect, useRef, useState } from "react"
import "./MyParadiseProfileImage.css"
export const MyParadiseProfileImage = () => {
	const { data: profileImage, refetch: refetchProfilePicture } = useGetProfileImage()
	const inputFileRef = useRef(null)

	const [deleteProfileImage] = useDeleteProfileImage()
	const [saveProfileImage] = useSaveProfileImage()
	const [imgToggle, setImgToggle] = useState(false)
	const [image, setImage] = useState()

	const { addToast } = useToasts()

	useEffect(() => {
		if (profileImage) {
			setImage(profileImage.base64String)
		}
	}, [profileImage])

	const deleteUserProfileImage = async () => {
		const result = await deleteProfileImage()
		result && setImage(null)
	}

	const onButtonClick = e => {
		e.stopPropagation()
		inputFileRef.current.click()
	}

	const handleFileUpload = e => {
		let image = e.target.files
		saveProfileImage({ image: image[0] }).then(() => {
			refetchProfilePicture()
			setImgToggle(false)
		})
	}

	const handleFileDrop = e => {
		e.preventDefault()
		let image = e.dataTransfer.files
		if (image.length < 2 && image[0].type.includes("image")) {
			try {
				saveProfileImage({ image: image[0] })
				imgToggle(false)
			} catch (error) {
				if (error instanceof Error) {
					addToast({
						title: "unkown error. Status: ",
						body: error.toString(),
						variant: "danger",
					})
				}
			}
		}
	}
	return (
		<div
			style={{ backgroundImage: `url(${image})` }}
			className="profileImage circle border flex flex-center color-bg-secondary color-fg-white"
			onDragOver={e => e.preventDefault()}
			onDrop={handleFileDrop}
		>
			{image == null && <FontAwesomeIcon icon={faUser} />}

			<div className="imgDiv" onClick={() => setImgToggle(imgToggle ? false : true)}>
				<div className="fileuploader-menu-open">
					<FontAwesomeIcon size="xs" icon={faEllipsis} />
					{imgToggle && (
						<div className=" menuPopup flex flex-column color-bg-default border rounded-1 border-color-white">
							<div className="menuItem f4 p-3 mb-1" onClick={onButtonClick}>
								<input style={{ display: "none" }} type="file" accept=".jpg, .png, .jpeg" ref={inputFileRef} onInput={handleFileUpload} />
								<FontAwesomeIcon size="xs" className="mr-1" icon={faUpload} /> Upload
							</div>
							{/* {image && (
                                <div className="menuItem f4 p-3 mb-1">
                                    <FontAwesomeIcon size="sm" className="mr-1" icon={faPenToSquare} /> Edit
                                </div>
                            )} */}

							{image && (
								<div className="menuItem f4 p-3" onClick={() => deleteUserProfileImage()}>
									<FontAwesomeIcon size="sm" className="mr-1" icon={faTrash} /> Delete
								</div>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	)
}
